export const DEFAULT_COLORS = [
	'#FE5F50',
	'#FFD91A',
	'#27326B',
	'#EB6A28',
	'#05734E',
	'#8E3C8E',
	'#FFB829',
	'#A5E5F2',
	'#D55268',
];

export const getRandomDefaultColor = () => DEFAULT_COLORS[Math.floor(Math.random() * DEFAULT_COLORS.length)];
